/**
 * Korean Market Calendar Utility
 * Detects weekends and public holidays for the KRX market (2026).
 */

const KR_HOLIDAYS_2026 = [
    '2026-01-01', // New Year
    '2026-02-16', '2026-02-17', '2026-02-18', // Seollal
    '2026-03-01', '2026-03-02', // Samilil (Observed)
    '2026-05-04', '2026-05-05', // Children's Day (Observed)
    '2026-05-24', // Buddha's Birthday
    '2026-06-06', // Memorial Day
    '2026-08-15', '2026-08-17', // Liberation Day (Observed)
    '2026-09-24', '2026-09-25', '2026-09-26', // Chuseok
    '2026-10-03', '2026-10-05', // Gaecheonjeol (Observed)
    '2026-10-09', // Hangeul Day
    '2026-12-25'  // Christmas
];

/**
 * Returns true if the market is closed (Weekend or KR Public Holiday)
 */
export const isMarketClosed = () => {
    const now = new Date();
    const day = now.getDay();
    const dateStr = now.toISOString().split('T')[0];
    
    // Weekend (Sat=6, Sun=0)
    if (day === 0 || day === 6) return true;
    
    // Public Holiday
    if (KR_HOLIDAYS_2026.includes(dateStr)) return true;
    
    return false;
};
